import type { GetServerSideProps } from "next";
import * as 장치 from "../../components/장치";
import { CSR } from "../../components/CSR";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { match } from "ts-pattern";
import { 링크 } from "../../components/데이터/링크";

const ReRouter = ({ 장치 }: { 장치: 장치.t }) => {
  const router = useRouter();
  useEffect(() => {
    match(장치)
      .with("모바일", () => {
        router.replace(링크.마켓봄_간편가입_모바일);
      })
      .with("데스크탑", () => {
        router.replace(링크.마켓봄_간편가입_PC);
      })
      .otherwise(() => {
        router.replace(링크.마켓봄_간편가입_PC);
      });
  }, [router, 장치]);

  return <></>;
};

const JoinUs = ({ 장치 }: { 장치: 장치.t }) => {
  return (
    <CSR>
      <ReRouter 장치={장치} />
    </CSR>
  );
};

export default JoinUs;

export const getServerSideProps: GetServerSideProps = async (ctx) => ({
  props: { 장치: 장치.fromContext(ctx) },
});
